// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-field {
  position: relative;
  margin-bottom: 1rem;
  height: 50px;
}
.form-field ion-input {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid #E8E8E8;
  border-radius: 0.5rem;
  outline: none;
  padding: 1rem;
  background: none;
  z-index: 1;
  color: #171c25;
  --padding-top: 1rem;
  --padding-bottom: 1rem;
  --padding-start: .75rem;
  --padding-end: .5rem;
}
.form-field ion-input:focus {
  border-color: var(--ion-color-primary);
}
.form-field label {
  left: 0;
  top: 0;
  position: absolute;
  transform: translate(1rem, 1rem);
  transition: transform 0.25s;
  color: #939fab;
}
.form-field label.label-focused {
  transform: translate(0.8rem, -0.5rem);
  font-size: 14px;
  background-color: #fff;
  z-index: 10;
}
.form-field.has-icon {
  display: flex;
  align-items: center;
  padding-left: 0.75rem;
}
.form-field.has-icon label {
  transform: translate(2.25rem, 1rem);
}
.form-field.has-icon label.label-focused {
  transform: translate(0.8rem, -0.5rem);
}
.form-field.has-icon ion-input {
  --padding-start: 2.25rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/form-field/input/input.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;AACJ;AAEI;EACE,sCAAA;AAAN;AAGE;EACE,OAAA;EACA,MAAA;EACA,kBAAA;EACA,gCAAA;EACA,2BAAA;EACA,cAAA;AADJ;AAGI;EACE,qCAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAHJ;AAII;EACE,mCAAA;AAFN;AAGM;EACE,qCAAA;AADR;AAII;EACE,wBAAA;AAFN","sourcesContent":[".form-field {\n  position: relative;\n  margin-bottom: 1rem;\n  height: 50px;\n\n  ion-input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    font-size: 1rem;\n    font-weight: 500;\n    border: 1px solid #E8E8E8;\n    border-radius: .5rem;\n    outline: none;\n    padding: 1rem;\n    background: none;\n    z-index: 1;\n    color: #171c25;\n    --padding-top: 1rem;\n    --padding-bottom: 1rem;\n    --padding-start: .75rem;\n    --padding-end: .5rem;\n\n    // &:not(:placeholder-shown),\n    &:focus {\n      border-color: var(--ion-color-primary);\n    }\n  }\n  label {\n    left: 0;\n    top: 0;\n    position: absolute;\n    transform: translate(1rem, 1rem);\n    transition: transform .25s;\n    color: #939fab;\n\n    &.label-focused {\n      transform: translate(0.8rem, -0.5rem);\n      font-size: 14px;\n      background-color: #fff;\n      z-index: 10;\n    }\n  }\n\n  &.has-icon {\n    display: flex;\n    align-items: center;\n    padding-left: 0.75rem;\n    label {\n      transform: translate(2.25rem, 1rem);\n      &.label-focused {\n        transform: translate(0.8rem, -0.5rem);\n      }\n    }\n    ion-input {\n      --padding-start: 2.25rem;\n    }\n  }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
